import { experiment } from "@faire/web/common/settings/declarations/experiment";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

/**
 * Batch 10 Top nav signup cta
 */
export const FE_BATCH_10_TOP_NAV_SIGNUP_CTA_250522 = experiment({
  name: "FE_BATCH_10_TOP_NAV_SIGNUP_CTA_250522",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-08-22",
  defaultValue: IFourVariantXP.Bucket.CONTROL,
  productArea: "LOGGED_OUT_RETAILERS",
});
